import { AxiosInstance } from "axios";
import { getBoardApiUrl } from "helpers";
import { CreateRunRequestModel } from "models/CreateRunRequestModel";
import { CreateRunResultModel } from "models/CreateRunResultModel";

export class EdecideApi {
  constructor(private axios: AxiosInstance) {}

  async getPreview(meetingId: number) {
    const url = getBoardApiUrl(`edecide/run/${meetingId}/preview`);
    const response = await this.axios.get<CreateRunRequestModel>(url);

    return response.data;
  }

  async createRun(meetingId: number, patch: object) {
    const url = getBoardApiUrl(`edecide/run/${meetingId}/create`);
    const response = await this.axios.post<CreateRunResultModel>(url, patch);

    return response.data;
  }
}
